document.addEventListener('DOMContentLoaded', function() {
    $("#main-carousel .play-button button").trigger("click");
});

// form input and control
// let imageFiles = [];
// image upload
$(".image-upload-input").on("change", function (event) {
	const files = this.files;
	// console.log(this);
	let imageHTML = `
	<div class="uploaded-image-container">
		<small data-index="${this.id}">x</small>
		<img src="${URL.createObjectURL(files[0])}" class="uploaded_img">
	</div>
	`;
	$(this).parent().hide();
	$(imageHTML).appendTo($(this).parent().parent())
	// $(this).parent().parent().add(imageHTML);
	$(".uploaded-image-container small").on("click", function(event) {
		removeImage(this)
	})
});

function removeImage(element) {
	console.log("clicked small", element);
	$(element).parent().parent().children("label").show();
	$(element).parent().parent().children("label").children("input").val("")
	$(element).parent().remove();
}


function createDescriptionModal() {
	if (window.innerWidth < 1024) {
		console.log("create description modal");
		$(".anchor-tabs ul li button").modaal({
			type: "inline",
			content_source: ".modal-window",
			before_open: function (e) {
				// fetch product info
				const informationElement = document.querySelector(`div#${e.currentTarget.id}.tab-content`);
				const modalView = document.querySelector(".modal-view");
				modalView.innerHTML = `<div class="modal-tab-content">${informationElement.innerHTML}</div>`;
			},
			after_close: function () {
				const modalView = document.querySelector(".modal-view");
				modalView.innerHTML = "";
			},
		});
	}
}

createDescriptionModal();

window.addEventListener("resize", function () {
	createDescriptionModal();
});  

document.addEventListener('DOMContentLoaded', function() {
  $(document).on('click', '.anchor-tabs a[href^="#"], .anchor-tabs button[id]', function(e) {
    e.preventDefault();
    var target = $(this).attr('href') || '#' + $(this).attr('id');
    if (!$(target).length) return;
    var headerHeight = $('.new_header_fine').outerHeight() || 0;
    $('html, body').animate({ scrollTop: $(target).offset().top - headerHeight }, 800);
  });
});
